import React from 'react';
import {Input, Select, Form, Modal,message } from 'antd';
import moment from 'moment';



const formItemLayout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 14,
  },
}

const formLargeItemLayout = {
  labelCol: {
    span: 3,
  },
  wrapperCol: {
    span: 19,
  },
}

const modalMaster = ({
	visible,
	type,
	item = {},
	onOk,
	onCancel,
	form: {
	  getFieldDecorator,
	  validateFields,
	  getFieldsValue,
	},
	}) => {

	function handleOk () {
		validateFields((err, values) => {
		
		if(err){return }

	  //如果是 Select InputNumber 作为输入组件；如果不填返回的是 undefined，应该变成 null
      //if(values.cid == item.cid){delete values.cid; } else {if(typeof(values.cid)=="undefined"){values.cid = null; }}	  
		if (values.value_array ==item.value){delete values.value_array} else {if(typeof(values.value_array)=="undefined"){values.value_array = {}; }}	
		//int字段类型如果是空，视同Null处理
		if (values.value_int ===''  ){values.value_int =null} 
		
		//json字段处理
		if (values.value_json  ){
			try{
				values.value_json  = JSON.parse(values.value_json)
			}catch(e){
				delete values.value_json
				return message.error('value_json转换失败，可能是格式不对')
			}
		}else{values.value_json ={}}

		if (Object.getOwnPropertyNames(values).length == 0) {
		  onCancel()
		  return
		}
	  
	  if(item.id){values.id = item.id} //如果是变更，item有内容，把id给到values

		onOk(values)      

	  })
	}

	const modalOpts = {
	  title: `${type === 'create' ? '新建' : '修改'}`,
	  visible,
	  onOk: handleOk,
	  onCancel,
	  wrapClassName: 'vertical-center-modal',
	  width: 520,
	  //okText: '确认',
      //cancelText: '取消',
	}

	
	return (
	  <Modal {...modalOpts}>
		<Form layout="horizontal">
		
		<Form.Item label={'class_name'} {...formItemLayout} >
		   {getFieldDecorator('class_name', {
				initialValue: item.class_name,
				rules: [{ required: true, message: 'Please input your class_name!' }],
			  }
			)(
			<Input placeholder="参数类别"/>   
			)}
		</Form.Item>  
		<Form.Item label={'name'} {...formItemLayout} >
		   {getFieldDecorator('name', {
			   rules: [{ required: true, message: 'Please input your name!' }],
				initialValue: item.name,
			  }
			)(
			<Input placeholder="参数名称"/>   
			)}
		</Form.Item>		
		<Form.Item label={'code'} {...formItemLayout} >
		   {getFieldDecorator('code', {
				initialValue: item.code,
			  }
			)(
			<Input placeholder="参数名称"/>   
			)}
		</Form.Item> 
		         
		<Form.Item label={'value_string'} {...formItemLayout} >
		   {getFieldDecorator('value_string', {
				initialValue: item.value_string,
			  }
			)(
			<Input placeholder="文本内容"/>   
			)}
		</Form.Item>  
		<Form.Item label={'value_int'} {...formItemLayout} >
		   {getFieldDecorator('value_int', {
				initialValue: item.value_int,
			  }
			)(
			<Input placeholder="纯数字"/>   
			)}
		</Form.Item>  		
		<Form.Item label={'value_json'} {...formItemLayout} >
		   {getFieldDecorator('value_json', {
				initialValue: JSON.stringify(item.value_json),
			  }
			)(
			<Input  placeholder='{"a":1,"b":"张三"}'/>   
			)}
		</Form.Item>         
		       
		<Form.Item label={'value_array'} {...formItemLayout} >
		   {getFieldDecorator('value_array', {
				initialValue: item.value_array,
			  }
			)(
			<Select  mode="tags"  placeholder="选择或输入项目" style={{ width: '100%' }} >
			  <Select.Option key='1' value='男'>男</Select.Option>
			  <Select.Option key='2' value='女'>女</Select.Option>
			  <Select.Option key='3' value='大经'>大经</Select.Option>
			  <Select.Option key='4' value='子公司'>子公司</Select.Option>
			</Select>  
			)}
		</Form.Item> 
		
				<Form.Item label={'remarks'} {...formItemLayout} >
		   {getFieldDecorator('remarks', {
				initialValue: item.remarks,
			  }
			)(
			<Input placeholder="文本内容,备注"/>   
			)}
		</Form.Item> 
		</Form>
	  </Modal>
	)
}


const ModalRender = Form.create()(modalMaster); 


export default ModalRender;
